<template>
    <div class="orderBoxApp">
        <div v-if="!productReady" class="text-center marginbottom20"><img src='/layouts/main/styles/images/spinner.gif' /> Loading product information...</div>
        <order-info-header v-if="$root._data.type != 'main' && productReady" :type="$root._data.type">
            <div v-html="serviceContent" class="reading-len"
                v-if="$root._data.type == 'service'"></div>
        </order-info-header>
        <div class="prodBox" v-if="productReady">
            <product-box v-for="product in products" :key="product.id" :product="product" :type="$root._data.type">
                <product-config :product="product" :main="$root._data.type == 'main'" :preConfig="''"></product-config>
            </product-box>
        </div>
    </div>
</template>

<script>
import orderInfoHeader from './components/orderInfoHeader';
import productBox from './components/productBox';
import useProductInfo from './composables/useProductInfo';
import productConfig from './components/productConfig';
import { computed } from '@vue/composition-api';

export default {
    name: 'App',
    components: {
        orderInfoHeader,
        productBox,
        productConfig
    },
    setup: function () {
        const {
            getProductInfo,
            products,
            orderMeta,
            getProductServiceContent,
            serviceContent,
            getOrderMetaData
        } = useProductInfo();

        const productReady = computed(() => {
            return products.value.length || serviceContent.value != '' && serviceContent.value != null;
        });

        return {
            getProductInfo,
            products,
            orderMeta,
            getProductServiceContent,
            serviceContent,
            getOrderMetaData,
            productReady
        }
    },
    created: function () {
        this.getProductInfo(this.$root._data.prodid, this.$root._data.model, this.$root._data.type);
        this.getOrderMetaData();
    },
    watch: {
        products: function (newVal) {
            if (newVal.length == 0 && this.$root._data.type != 'service') {
                this.unmountApp();
            } else if (newVal.length == 0 && this.$root._data.type == 'service') {
                this.getProductServiceContent(this.$root._data.prodid);
            }
        },
        serviceContent: function (newVal) {
            if (newVal == '' && this.products.length == 0) {
                this.unmountApp();
            }
        }
    },
    methods: {
        closeEditCart: function () {
            window.closeEditCartItem();
        },
        unmountApp: function () {
            var parentContainer = window.$(this.$el).closest('.container-fluid');
            parentContainer.prev('hr').remove();
            parentContainer.remove();
            this.$destroy();
        }
    }
}
</script>
